import React, { useEffect, useRef, useState } from 'react';
import QRCode from 'qrcode';

function QRModal({ url, monthLabel, onClose }) {
  const canvasRef = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (canvasRef.current && url) {
      QRCode.toCanvas(canvasRef.current, url, {
        width: 280,
        margin: 2,
        color: { dark: '#1a1a1e', light: '#ffffff' },
      }, (err) => {
        if (err) setError(err.message);
      });
    }
  }, [url]);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="qr-modal" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>&times;</button>
        <div className="qr-print-area">
          <canvas ref={canvasRef} className="qr-canvas" />
          <div className="qr-label">{monthLabel}</div>
        </div>
        {error && <div style={{ color: '#ff6b6b', fontSize: '0.85rem', marginTop: 8 }}>{error}</div>}
        <div className="qr-url">{url}</div>
        <button className="qr-print-btn" onClick={handlePrint}>Print QR Sticker</button>
      </div>
    </div>
  );
}

export default QRModal;
